/**
 * "Каталог" mega panel (rail + sub-panels).
 *
 * Тригери: будь-який [data-catalog-trigger] (у nav-рядку A та блоці пошуку B).
 * Панель: #hdr-catalog (рендериться один раз у #masthead).
 * Ліворуч — рейл категорій; наведення/клік по категорії перемикає панель
 * підкатегорій праворуч.
 */
document.addEventListener('DOMContentLoaded', () => {
	const panel = document.getElementById('hdr-catalog');
	const triggers = Array.from(document.querySelectorAll('[data-catalog-trigger]'));
	if (!panel || triggers.length === 0) return;

	let closeTimer = null;

	const setExpanded = (state) => {
		triggers.forEach((t) => t.setAttribute('aria-expanded', state ? 'true' : 'false'));
	};

	const open = () => {
		clearTimeout(closeTimer);
		// Close any open nav mega-menus.
		document.querySelectorAll('.main-nav__item.is-open').forEach((i) => {
			i.classList.remove('is-open');
			const trig = i.querySelector('.main-nav__link--has-submenu');
			if (trig) trig.setAttribute('aria-expanded', 'false');
		});
		panel.classList.add('is-open');
		setExpanded(true);
	};

	const close = (delay = 0) => {
		clearTimeout(closeTimer);
		closeTimer = setTimeout(() => {
			panel.classList.remove('is-open');
			setExpanded(false);
		}, delay);
	};

	const isOpen = () => panel.classList.contains('is-open');

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			isOpen() ? close() : open();
		});
		trigger.addEventListener('mouseenter', () => {
			if (window.matchMedia('(hover: hover)').matches) open();
		});
		trigger.addEventListener('mouseleave', () => {
			if (window.matchMedia('(hover: hover)').matches) close(160);
		});
	});

	panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
	panel.addEventListener('mouseleave', () => {
		if (window.matchMedia('(hover: hover)').matches) close(160);
	});

	// ── Rail switching ──────────────────────────────────────
	// Вміст панелі приходить фрагментом (menu-fragments.js), тож категорії шукаємо
	// в момент події, а слухаємо делегуванням на самій панелі.
	const activate = (cat) => {
		const targetId = cat.getAttribute('data-cat-target');
		panel.querySelectorAll('.hdr-catalog__cat').forEach((c) => {
			const on = c === cat;
			c.classList.toggle('is-active', on);
			c.setAttribute('aria-selected', on ? 'true' : 'false');
		});
		panel.querySelectorAll('.hdr-catalog__panel').forEach((p) => p.classList.toggle('is-active', p.id === targetId));
	};

	// Safety net: ensure one category is active.
	const ensureActive = () => {
		const first = panel.querySelector('.hdr-catalog__cat');
		if (first && !panel.querySelector('.hdr-catalog__cat.is-active')) activate(first);
	};
	ensureActive();
	document.addEventListener('helixwave:menus-ready', ensureActive);

	const catFrom = (e) => e.target.closest && e.target.closest('.hdr-catalog__cat');
	panel.addEventListener('mouseover', (e) => {
		const cat = catFrom(e);
		if (cat && !cat.classList.contains('is-active')) activate(cat);
	});
	panel.addEventListener('focusin', (e) => {
		const cat = catFrom(e);
		if (cat) activate(cat);
	});
	// On touch / click, first tap selects the category panel.
	panel.addEventListener('click', (e) => {
		const cat = catFrom(e);
		if (cat && !cat.classList.contains('is-active')) {
			e.preventDefault();
			activate(cat);
		}
	});

	// Outside click + ESC close.
	document.addEventListener('click', (e) => {
		if (isOpen() && !panel.contains(e.target) && !e.target.closest('[data-catalog-trigger]')) {
			close();
		}
	});
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && isOpen()) close();
	});
});
